/**
 * Graphics Reference Configuration
 *
 * TEMPORARY SOLUTION - Remove after 2026-02-06
 *
 * Maps UUID-based graphic refs (new system) to legacy string refs (old system)
 * for backwards compatibility during migration period.
 */

import { validate as isValidUUID } from "uuid";

/**
 * Legacy graphic reference names (pre-UUID system)
 */
export const LegacyGraphicRef = {
	// League Tables & Standings
	LeagueTable: "LeagueTable",
	LeagueTableFull: "LeagueTableFull",
	LeagueTableHalf: "LeagueTableHalf",
	LowerThirdStats: "LowerThirdStats",
	SideBarStandings: "SideBarStandings",

	// Fixtures & Results
	LBarResults: "LBarResults",
	LBarSchedule: "LBarSchedule",

	// Lineups
	LineupFull: "LineupFull",
	LineupTicker: "LineupTicker",
	LineupTactical: "LineupTactical",

	// Statistics & Scorers
	BottomGoalScorers: "BottomGoalScorers",
	BottomStats: "BottomStats",
	MatchStatistics: "MatchStatistics",

	// Rugby
	rugbyXVGraphic: "rugbyXVGraphic",
} as const;

export type LegacyGraphicRef = (typeof LegacyGraphicRef)[keyof typeof LegacyGraphicRef];

/**
 * UUID to legacy ref mappings
 * Add new mappings as graphics packages are migrated
 */
export const TEMPORARY_GRAPHIC_REF_MAPPINGS: Record<string, LegacyGraphicRef> = {
	"07085ade-db04-4089-9aa9-429997db677c": LegacyGraphicRef.LeagueTableFull,
	"907391e6-48fa-46a4-ab0e-6d4a17556c03": LegacyGraphicRef.LeagueTableHalf,
	"ca972216-6d99-4ddd-bc99-34feaa481fb3": LegacyGraphicRef.LBarResults,
	"64abb73b-b0ff-4855-bd05-4424d20cc652": LegacyGraphicRef.LeagueTableHalf,
	"0df6e7bd-0ac7-4efa-aeec-ed7485caa694": LegacyGraphicRef.LineupFull,
};

/**
 * Resolves a graphic ref (UUID or legacy) to its legacy ref name
 */
export function resolveGraphicRef(ref: string): string {
	// Already a legacy ref
	if (Object.values(LegacyGraphicRef).includes(ref as LegacyGraphicRef)) {
		return ref;
	}

	// UUID with mapping
	if (isValidUUID(ref)) {
		const legacyRef = TEMPORARY_GRAPHIC_REF_MAPPINGS[ref];

		if (legacyRef) {
			return legacyRef;
		}
	}

	return ref;
}
